import { apiCall } from "../configs/axiosConfigs";
const BASE_URL = `/ecommerce/cart`;

const withQuery = (base, params) => {
  if (!params) return base;
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  return qs ? `${base}?${qs}` : base;
};

export const cartApi = {
  async getCartByUser(idUser) {
    return apiCall({
      url: `${BASE_URL}/user/${idUser}`,
      method: "GET",
    });
  },
  async getCost(jsonShipping) {
    return apiCall({
      url: `${BASE_URL}/cost`,
      method: "POST",
      data: jsonShipping,
    });
  },
  async confirmShipping(jsonOrder) {
    return apiCall({
      url: `${BASE_URL}/confirmOrder`,
      method: "POST",
      data: jsonOrder,
    });
  },
  async clearPurchasedItems({ orderId, idUser, folioPedido, cartIds }) {
    return apiCall({
      url: `${BASE_URL}/clearPurchased`,
      method: "POST",
      data: { orderId, idUser, folioPedido, cartIds },
    });
  },
};

export const urlMakePageFetcherCart = {
  url: `${BASE_URL}/user`,
  method: "GET"
};

export { withQuery };
